import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Divider,
  Flex,
  Text,
  Icon,
  Box,
  Portal,
} from "@chakra-ui/react";
import { FaInfoCircle } from "react-icons/fa";
import { SupplierPart } from "./utils/partsCalculationUtils";

interface SupplierQuantityCellProps {
  part: SupplierPart;
}

export const SupplierQuantityCell = ({ part }: SupplierQuantityCellProps) => {
  const quantity = part.familyQuantity ?? "N/A";
  const adjustments = part.adjustments || [];

  if (adjustments.length === 0) {
    return <>{quantity}</>;
  }

  return (
    <Box position="relative" display="inline-block">
      <Text as="span">{quantity}</Text>

      <Popover
        trigger="hover"
        placement="right"
        autoFocus={false}
        openDelay={0}
        closeDelay={100}
      >
        <PopoverTrigger>
          <span
            style={{
              position: "absolute",
              top: "50%",
              left: "100%",
              transform: "translateY(-50%)",
              marginLeft: "4px",
              cursor: "help",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            {/* Restored your boxSize="15px" */}
            <Icon as={FaInfoCircle} boxSize="15px" color="gray.400" />
          </span>
        </PopoverTrigger>

        {/* Added Portal for the clipping bug */}
        <Portal>
          <PopoverContent
            bg="white"
            borderColor="gray.200"
            shadow="md"
            w="auto"
            minW="210px"
            _focus={{ outline: "none" }}
            zIndex="popover"
            fontFamily="'Nunito', sans-serif"
          >
            <PopoverArrow bg="white" borderColor="gray.200" />
            <PopoverBody p={0} textAlign="left">
              <Flex justify="space-between" align="center" px={3} pt={3} pb={2}>
                {/* Restored your color="black" edit */}
                <Text fontSize="xs" color="black">
                  {part.source ?? "Reported by supplier"}
                </Text>
                <Text fontSize="xs" fontWeight="bold" color="green.600" ml={8}>
                  {part.supplierReportedQuantity ?? "-"}
                </Text>
              </Flex>

              <Text fontSize="xs" color="black" px={3} pb={1}>
                Adjustment(s)
              </Text>

              {adjustments.map((adj, idx) => (
                <Flex
                  key={idx}
                  justify="space-between"
                  align="center"
                  px={3}
                  pb={1}
                  pl={5}
                >
                  <Text fontSize="xs" color="gray.500">
                    • {adj.label}
                  </Text>
                  <Text
                    fontSize="xs"
                    color={adj.value < 0 ? "green.500" : "red.500"}
                    fontWeight="semibold"
                    ml={8}
                  >
                    {/* Negative = stock added back (sheet above Typesense). */}
                    {adj.value < 0 ? `+${-adj.value}` : adj.value}
                  </Text>
                </Flex>
              ))}

              <Divider borderColor="gray.200" mt={1} />

              <Flex justify="space-between" align="center" px={3} py={2}>
                <Text fontSize="xs" color="black">
                  Net Available
                </Text>
                <Text fontSize="xs" fontWeight="bold" color="green.600" ml={8}>
                  {quantity}
                </Text>
              </Flex>
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
    </Box>
  );
};
